import React, { useCallback, useEffect, useState } from 'react';
import { IntlShape, RawIntlProvider } from 'react-intl';
import intl from '~/utils/intl/intl-proxy';

interface Props {
  children: React.ReactNode;
}

const MyIntlProvider: React.FC<Props> = ({ children }) => {
  const [intlState, setIntlState] = useState<IntlShape>(intl.getIntl());

  const onIntlChanged = useCallback((newIntl: IntlShape) => {
    setIntlState(newIntl);
  }, []);

  useEffect(() => {
    intl.subscribe(onIntlChanged);
    return () => intl.unsubscribe(onIntlChanged);
  }, [onIntlChanged]);

  return <RawIntlProvider value={intlState}>{children}</RawIntlProvider>;
};

export default React.memo(MyIntlProvider);
